module.exports = __webpack_public_path__ + "static/media/mochacake.e25ee9fd.jpg";